import {
  IStepAddOrderFormValues,
  IStepAggregationTableReport,
  IStepTablesSearchParam,
} from "../../Interfaces/stepInterfaces";
import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getStepAggregationTable } from "../../Requests/stepRequests";
import { useAppDispatch } from "../../App/hooks";
import { setStepAddOrderFormValues } from "../../Features/Step/stepSlice";
import { store } from "../../App/store";

interface IProps {
  searchParam: IStepTablesSearchParam;
}

const AggregationTable = ({ searchParam }: IProps) => {
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: IStepAggregationTableReport) => {
    console.log({ row });

    dispatch(
      setStepAddOrderFormValues({
        ...store.getState().step.addOrderFormValues,
        instrumentId: row?.instrumentId,
        instrumentType: row?.type,
      } as IStepAddOrderFormValues)
    );
  };

  return (
    <TableTemplate<IStepTablesSearchParam, IStepAggregationTableReport>
      refreshTableTime={5000}
      getDataTable={getStepAggregationTable}
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="max-h-[500px] overflow-auto !min-w-full"
          onTableRowClick={tableRowClickHandler}
        />
      )}
      searchParameters={searchParam}
    />
  );
};

export default AggregationTable;
